export default {
  currentUser: null,
};
